import { certificateRows } from 'components/Deal/Enquiries/shared/Summary/Certificates/CertificatesFormModal/constants';
import { CertificateName, ServiceType } from 'interfaces';

export default {
  value: ServiceType.Certificates,
  label: 'Certifications',
  defaultName: '',
  children: [
    {
      value: CertificateName.Compliance21,
      label: certificateRows[CertificateName.Compliance21].title,
      defaultName: certificateRows[CertificateName.Compliance21].title,
    },
    {
      value: CertificateName.Compliance22,
      label: certificateRows[CertificateName.Compliance22].title,
      defaultName: certificateRows[CertificateName.Compliance22].title,
    },
    {
      value: CertificateName.Origin,
      label: certificateRows[CertificateName.Origin].title,
      defaultName: certificateRows[CertificateName.Origin].title,
    },
    {
      value: CertificateName.Materials31,
      label: certificateRows[CertificateName.Materials31].title,
      defaultName: certificateRows[CertificateName.Materials31].title,
    },
    {
      value: CertificateName.Materials31v2,
      label: certificateRows[CertificateName.Materials31v2].title,
      defaultName: certificateRows[CertificateName.Materials31v2].title,
    },
    {
      value: CertificateName.MaterialsPlastic,
      label: certificateRows[CertificateName.MaterialsPlastic].title,
      defaultName: certificateRows[CertificateName.MaterialsPlastic].title,
    },
    {
      value: 'cert_materials_3_2',
      label: 'Material certificate type 3.2 according to EN 10204',
      defaultName: 'Material certificate type 3.2 according to EN 10204',
    },
    {
      value: CertificateName.HeatTreatment,
      label: certificateRows[CertificateName.HeatTreatment].title,
      defaultName: certificateRows[CertificateName.HeatTreatment].title,
    },
    {
      value: CertificateName.Rohs,
      label: certificateRows[CertificateName.Rohs].title,
      defaultName: certificateRows[CertificateName.Rohs].title,
    },
  ],
};
